var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ripple",class:{ success: _vm.isSuccess && !_vm.isFailure, failure: !_vm.isSuccess && _vm.isFailure },on:{"click":function($event){return _vm.buttonClick()}}},[_vm._v(_vm._s(_vm.textToDisplay))])}
var staticRenderFns = []

export { render, staticRenderFns }